var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 19,
    viewBox: "0 0 10 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#4258bf",
    d: "M7.264 8.715l-3.75-1.097a1.024 1.024 0 0 1 .288-2.007h2.302c.424 0 .84.128 1.188.364a.541.541 0 0 0 .677-.07l1.209-1.18a.563.563 0 0 0-.063-.851 4.91 4.91 0 0 0-3.004-1.042V1.165a.557.557 0 0 0-.556-.556h-1.11a.557.557 0 0 0-.557.556v1.667h-.086c-2.213 0-3.99 1.9-3.786 4.154.146 1.6 1.368 2.903 2.91 3.354l3.56 1.042a1.024 1.024 0 0 1-.288 2.007H3.895a2.12 2.12 0 0 1-1.187-.364.541.541 0 0 0-.678.07l-1.208 1.18a.563.563 0 0 0 .062.851 4.91 4.91 0 0 0 3.004 1.042v1.667c0 .306.25.556.556.556h1.111c.306 0 .556-.25.556-.556v-1.674c1.619-.031 3.136-.993 3.671-2.525.747-2.14-.507-4.334-2.518-4.92z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.d70ace1e94c8e98973d92a918383fd70.svg";
export { ForwardRef as ReactComponent };